import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ComingSoonComponent } from '../pages/Not-Found/coming-soon/coming-soon.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ImageModalComponent } from './image-modal/image-modal.component';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    NzModalModule,
    NzButtonModule,
    ComingSoonComponent,
    ImageModalComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    ComingSoonComponent,
    ImageModalComponent
  ],
  // LanguageService is providedIn 'root'. Providing it here as well gave each
  // routed standalone component that imports this module its own copy, so the
  // header's language switch never reached the Layout listening to another one
  // (AI sheet row 39: an English launcher left beside the Arabic one).
  providers: [],
})
export class SharedModule { }
